import React, { useMemo, useState } from 'react';
import { Badge, Button, Col, Form, ListGroup, Modal, Row } from 'react-bootstrap';
import { filterReactionSpells, formatComponents, reactionSpells } from '../utils/reactionSpells';

const levelLabel = (level) => Number(level) === 0 ? 'Cantrip (level 0)' : `Level ${level}`;

export function SpellPreview({ spell }) {
  if (!spell) return <p className="text-muted">Choose a spell to preview its rules.</p>;
  return <article data-testid="reaction-spell-preview">
    <h5>{spell.name} <Badge bg="secondary">{levelLabel(spell.level)}</Badge></h5>
    <dl className="row small mb-2">
      <dt className="col-4">Casting Time</dt><dd className="col-8">{spell.castingTime}</dd>
      <dt className="col-4">Reaction Trigger</dt><dd className="col-8">{spell.castingTrigger || 'Not specified'}</dd>
      <dt className="col-4">Range</dt><dd className="col-8">{spell.range || '—'}</dd>
      <dt className="col-4">Components</dt><dd className="col-8">{formatComponents(spell)}</dd>
      <dt className="col-4">Duration</dt><dd className="col-8">{spell.duration || '—'}</dd>
    </dl>
    <p style={{ whiteSpace: 'pre-line' }}>{spell.description}</p>
    {spell.higherLevels && <p><strong>Using a Higher-Level Spell Slot.</strong> {spell.higherLevels}</p>}
  </article>;
}

export default function ReactionSpellPicker({ show, onHide, onSelect }) {
  const [query, setQuery] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const results = useMemo(() => filterReactionSpells(query), [query]);
  const selected = reactionSpells.find((spell) => spell.id === selectedId);
  return <Modal show={show} onHide={onHide} size="lg" centered scrollable className="dnd-modal">
    <Modal.Header closeButton><Modal.Title>Add Reaction Spell</Modal.Title></Modal.Header>
    <Modal.Body><Row className="g-3"><Col md={5}>
      <Form.Control type="search" aria-label="Search reaction spells" placeholder="Search reaction spells" value={query} onChange={(event) => setQuery(event.target.value)} />
      <ListGroup className="mt-2 reaction-spell-results">{results.map((spell) => <ListGroup.Item action active={selectedId === spell.id} key={spell.id} onClick={() => setSelectedId(spell.id)}><strong>{spell.name}</strong><div className="small">{levelLabel(spell.level)} · {spell.castingTime}</div></ListGroup.Item>)}</ListGroup>
      {!results.length && <p className="mt-3 text-muted">No reaction spells match that search.</p>}
    </Col><Col md={7}><SpellPreview spell={selected} /></Col></Row></Modal.Body>
    <Modal.Footer><Button variant="secondary" onClick={onHide}>Cancel</Button><Button disabled={!selected} onClick={() => onSelect(selected)}>Select Spell</Button></Modal.Footer>
  </Modal>;
}
